const minimumScreenSpan = 414;
const deviceIsTooSmall =
  window.innerWidth <= minimumScreenSpan ||
  window.innerHeight <= minimumScreenSpan;

export const isiPhone =
  navigator.userAgent && /iPhone|iPod/.test(navigator.userAgent);

export const isAndroid =
  navigator.userAgent && /Android/i.test(navigator.userAgent);

export const isMobileDevice =
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    navigator.userAgent
  ) && deviceIsTooSmall;

export const isTablet =
  /(ipad|macintosh|macintel|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(
    navigator.userAgent
  ) &&
  navigator.maxTouchPoints &&
  navigator.maxTouchPoints > 2;

export const isIpad =
  /iPad/.test(navigator.platform) ||
  (navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform));
